import { setSearch } from '../../search-and-filter-schema/protected';
const updateSearchFilter = (filters, filterValue) => {
  return setSearch(filterValue, filters);
};
export default updateSearchFilter;